import { Routes } from "@angular/router";

import { packagesManagementRoutes, packagesListRoutes } from "./nested-features/packages";
import { guidedToursManagementRoutes, guidedToursRoutes } from "./nested-features/guided-tours-programs";

import { Permissions } from "src/assets/config/config";
import { servicesManagementResolver } from "./resolvers";

import { hallsManagementRoutes, hallsRoutes } from "./nested-features/halls";
import { couponsManagementRoutes, couponsRoutes } from "./nested-features/coupons";
import { productsManagementRoutes, productsRoutes } from "./nested-features/products";
import { groupOffersManagementRoutes, groupOffersRoutes } from "./nested-features/group-offers";
import { audioDevicesManagementRoutes, audioDevicesRoutes } from "./nested-features/audio-devices";
import { visitorPricesManagementRoutes, visitorPricesRoutes } from "./nested-features/visitor-prices";
import { museumBuildingsManagementRoutes, museumBuildingsRoutes } from "./nested-features/museum-buildings";

export const servicesManagementRoutes: Routes = [
  {
    path: "",
    title: "SERVICES.SERVICES_MANAGEMENT",
    resolve: {
      tabs: servicesManagementResolver,
    },
    loadComponent: () =>
      import("src/app/shared/base-components/base-tabs-management/base-tabs-management.component").then(
        (c) => c.BaseTabsManagementComponent,
      ),
    children: [
      {
        path: "packages",
        data: { permissions: Permissions.Packages },
        children: packagesListRoutes,
      },
      {
        path: "guided-tours",
        data: { permissions: Permissions.GuidedTours },
        children: guidedToursRoutes,
      },
      {
        path: "products",
        data: { permissions: Permissions.Product },
        children: productsRoutes,
      },
      {
        path: "visitor-prices",
        data: { permissions: Permissions.VisitorPrices },
        children: visitorPricesRoutes,
      },
      {
        path: "museum-buildings",
        data: { permissions: Permissions.Museums },
        children: museumBuildingsRoutes,
      },
      {
        path: "group-offers",
        data: { permissions: Permissions.GroupOffers },
        children: groupOffersRoutes,
      },
      {
        path: "halls",
        data: { permissions: Permissions.Halls },
        children: hallsRoutes,
      },
      {
        path: "audio-devices",
        data: { permissions: Permissions.AudioDevices },
        children: audioDevicesRoutes,
      },
      {
        path: "coupons",
        data: { permissions: Permissions.Coupons },
        children: couponsRoutes,
      },
    ],
  },
  {
    path: "packages",
    data: { permissions: Permissions.Packages },
    children: packagesManagementRoutes,
  },
  {
    path: "guided-tours",
    data: { permissions: Permissions.GuidedTours },
    children: guidedToursManagementRoutes,
  },
  {
    path: "products",
    data: { permissions: Permissions.Product },
    children: productsManagementRoutes,
  },
  {
    path: "visitor-prices",
    data: { permissions: Permissions.VisitorPrices },
    children: visitorPricesManagementRoutes,
  },
  {
    path: "museum-buildings",
    data: { permissions: Permissions.Museums },
    children: museumBuildingsManagementRoutes,
  },
  {
    path: "group-offers",
    data: { permissions: Permissions.GroupOffers },
    children: groupOffersManagementRoutes,
  },
  {
    path: "halls",
    data: { permissions: Permissions.Halls },
    children: hallsManagementRoutes,
  },
  {
    path: "audio-devices",
    data: { permissions: Permissions.AudioDevices },
    children: audioDevicesManagementRoutes,
  },
  {
    path: "coupons",
    data: { permissions: Permissions.Coupons },
    children: couponsManagementRoutes,
  },
];
